import { useVersionCheck } from "@ryde/shared";

export const RydeTimers = (): null => {
  useVersionCheck();

  return null;
};
